module.exports = __webpack_public_path__ + "static/media/ava-4.2b88f4c1.png";